import React from 'react'
import {AuthConsumer} from './AuthProvider';
import {IAuthService} from "./services/auth-service";

function AuthCallback() {
    return (
        <AuthConsumer>
            {({ signinRedirectCallback }: IAuthService) => {
                void signinRedirectCallback();
                return <span>loading...</span>;
            }}
        </AuthConsumer>
    );
}

export default AuthCallback
